import { CollectionStateProps } from '../collectionStateProps';
import { createContext } from '../../createContext';

export interface CollectionToolbarContext<T> extends CollectionStateProps<T> {}
const { useContext, Provider } =
  createContext<CollectionToolbarContext<any>>('CollectionToolbar');

export const CollectionToolbarProvider = Provider;
export const useCollectionToolbar = useContext;
